import React, { useState } from 'react';
import { SearchIcon, FilterIcon, CalendarIcon } from 'lucide-react';
import { ListingCard } from '../components/ListingCard';
import { allEvents } from '../data/mockData';
export function EventsPage() {
  const [searchTerm, setSearchTerm] = useState('');
  const [sortBy, setSortBy] = useState('date');
  const filteredEvents = allEvents.filter(item => item.title.toLowerCase().includes(searchTerm.toLowerCase()) || item.description.toLowerCase().includes(searchTerm.toLowerCase())).sort((a, b) => {
    if (sortBy === 'views') return b.views - a.views;
    return new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime();
  });
  return <main className="min-h-screen bg-gray-50" data-id="element-334">
      {/* Hero Section */}
      <section className="bg-gradient-to-r from-red-700 to-red-600 text-white py-16 px-4" data-id="element-335">
        <div className="max-w-4xl mx-auto text-center" data-id="element-336">
          <h1 className="text-4xl md:text-5xl font-bold mb-4" data-id="element-337">
            Upcoming Events
          </h1>
          <p className="text-xl text-red-100" data-id="element-338">
            Discover exciting events happening in Nakuru's creative community
          </p>
        </div>
      </section>

      <section className="py-8 px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto" data-id="element-339">
        {/* Search and Filter */}
        <div className="bg-white rounded-xl shadow-md p-4 mb-8" data-id="element-340">
          <div className="flex flex-col md:flex-row gap-4" data-id="element-341">
            <div className="flex-1 relative" data-id="element-342">
              <SearchIcon className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-5 h-5" data-id="element-343" />
              <input type="text" value={searchTerm} onChange={e => setSearchTerm(e.target.value)} placeholder="Search events..." className="w-full pl-10 pr-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-red-500 focus:border-transparent" data-id="element-344" />
            </div>
            <div className="flex items-center space-x-2" data-id="element-345">
              <FilterIcon className="text-gray-400 w-5 h-5" data-id="element-346" />
              <select value={sortBy} onChange={e => setSortBy(e.target.value)} className="px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-red-500 focus:border-transparent" data-id="element-347">
                <option value="date" data-id="element-348">By Date</option>
                <option value="views" data-id="element-349">Most Viewed</option>
              </select>
            </div>
          </div>
        </div>

        {/* Featured Event Banner */}
        {filteredEvents.length > 0 && <div className="bg-gradient-to-r from-red-600 to-orange-500 rounded-xl p-6 mb-8 text-white" data-id="element-350">
            <div className="flex items-center space-x-2 mb-2" data-id="element-351">
              <CalendarIcon className="w-5 h-5" data-id="element-352" />
              <span className="text-sm font-medium" data-id="element-353">Featured Event</span>
            </div>
            <h3 className="text-2xl font-bold mb-2" data-id="element-354">
              {filteredEvents[0].title}
            </h3>
            <p className="text-red-100 mb-4" data-id="element-355">{filteredEvents[0].description}</p>
            <div className="flex items-center space-x-4 text-sm" data-id="element-356">
              <span data-id="element-357">{filteredEvents[0].eventDate}</span>
              <span data-id="element-358">{filteredEvents[0].eventTime}</span>
              <span data-id="element-359">{filteredEvents[0].location}</span>
            </div>
          </div>}

        {/* Results Count */}
        <p className="text-gray-600 mb-6" data-id="element-360">
          Showing {filteredEvents.length}{' '}
          {filteredEvents.length === 1 ? 'event' : 'events'}
        </p>

        {/* Events Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6" data-id="element-361">
          {filteredEvents.map(item => <ListingCard key={item.id} listing={item} data-id="element-362" />)}
        </div>

        {filteredEvents.length === 0 && <div className="text-center py-12" data-id="element-363">
            <p className="text-gray-500 text-lg" data-id="element-364">
              No events found matching your search.
            </p>
          </div>}
      </section>
    </main>;
}